import * as React from 'react';
import { IAIcon } from '../icon/Icon';
import * as styles from './smallMenu.css'


export interface SmallMenuItem {
  translation: string;
  actionName: string;
  icon?: string;
  iconUrl?: string;
}

export interface IHeaderMenuProps {
  menuItems?: SmallMenuItem[];
  highlightColor: string;
  iconColor: string;
  styles?: React.CSSProperties;
  togglerSize?: number;
  isTogglerRotated?: boolean;
  isOverlayed?: boolean;
  onMenuItemClick?: (title: string) => void;
}


export interface IHeaderMenuState {
  isMenuOpen: boolean;
}


export class IASmallMenu extends React.Component<IHeaderMenuProps, IHeaderMenuState> {
  private menuRef: React.RefObject<HTMLDivElement>
  constructor(props: IHeaderMenuProps) {
    super(props);
    this.state = {
      isMenuOpen: false,
    };
    this.menuRef = React.createRef();
    this.handleClick = this.handleClick.bind(this);
  }

  private handleClick(event: Event) {
    if (this.menuRef && this.menuRef.current && !this.menuRef.current.contains(event.target as Node)) {
      if (this.state.isMenuOpen) {
        this.setState({ isMenuOpen: false })
      }
    }
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClick)
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClick);
  }

  public render(): JSX.Element {
    return (
      <div
        ref={this.menuRef}
        style={this.props.styles}
      >
        <button
          className="IA_OnFocus"
          aria-haspopup="menu"
          aria-expanded={this.state.isMenuOpen}
          aria-label="Open menu"
          style={{
            background: "none",
            border: "none",
            padding: 0,
            cursor: this.props.isOverlayed ? "default" : "pointer",
            opacity: this.props.isOverlayed ? 0.3 : 1,
            marginLeft: 5,
          }}
          onClick={() => {
            if (!this.props.isOverlayed) {
              this.setState({ isMenuOpen: !this.state.isMenuOpen });
            }
          }}
        >
          <IAIcon
            title="Show Action"
            size={this.props.togglerSize || 22}
            disableTabKey
            color={this.props.highlightColor ?? '#000'}
            style={{ transform: this.props.isTogglerRotated ? 'rotate(90deg)' : '' }}
          />
        </button>

        {this.state.isMenuOpen &&
          <ul className={styles.IA_smallMenu} role="menu">
            {this.props.menuItems.map((item) => (
              <li
                key={item.translation}
                role="menuitem"
                tabIndex={0}
                className={`IA_OnFocusOutline_outer ${styles.IA_menuItem}`}
                onClick={() => {
                  this.props.onMenuItemClick(item.actionName);
                  this.setState({ isMenuOpen: false });
                }}
                onKeyDown={(e: React.KeyboardEvent) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    this.props.onMenuItemClick(item.actionName);
                    this.setState({ isMenuOpen: false });
                  }
                  if (e.key === 'Escape') {
                    this.setState({ isMenuOpen: false });
                  }
                }}
              >
                <IAIcon
                  title={item.icon}
                  url={item.iconUrl}
                  size={20}
                  color={this.props.iconColor ?? '#000'}
                  style={{ marginRight: 8, lineHeight: "0px" }}
                  aria-hidden={true}
                />
                <span style={{ color: "#333333" }}>
                  {item.translation}
                </span>
              </li>
            ))}
          </ul>
        }
      </div>
    )
  }
}